import { ChainId } from '@uniswap/sdk-core';
export const DEFAULT_BLOCKS_TO_LIVE = {
    // (60 minutes) / (12 seconds)= 300
    [ChainId.MAINNET]: 300,
    [ChainId.GOERLI]: 300,
    [ChainId.SEPOLIA]: 300,
    // (60 minutes) / (2 seconds) = 1800
    [ChainId.OPTIMISM]: 1800,
    [ChainId.OPTIMISM_GOERLI]: 1800,
    [ChainId.OPTIMISM_SEPOLIA]: 1800,
    [ChainId.BASE]: 1800,
    [ChainId.ZORA]: 1800,
    [ChainId.BASE_GOERLI]: 1800,
    [ChainId.BASE_SEPOLIA]: 1800,
    [ChainId.ZORA_SEPOLIA]: 1800,
    [ChainId.BLAST]: 1800,
    // Note: Experiment with longer TTL
    // (12 hours) / (2 seconds) = 21600
    [ChainId.WORLDCHAIN]: 21600,
    // (60 minutes) / (1 seconds) = 3600
    [ChainId.UNICHAIN_SEPOLIA]: 3600,
    [ChainId.UNICHAIN]: 3600,
    [ChainId.MONAD_TESTNET]: 3600,
    // (60 minutes) / (250 milliseconds) = 14400
    [ChainId.ARBITRUM_ONE]: 14400,
    [ChainId.ARBITRUM_GOERLI]: 14400,
    [ChainId.ARBITRUM_SEPOLIA]: 14400,
    // (60 minutes) / (2 seconds) = 1800
    [ChainId.POLYGON]: 1800,
    [ChainId.POLYGON_MUMBAI]: 1800,
    // (60 minutes) / (5 seconds) = 720
    [ChainId.CELO]: 720,
    [ChainId.CELO_ALFAJORES]: 720,
    // (60 minutes) / (5 seconds) = 720
    [ChainId.GNOSIS]: 720,
    // (60 minutes) / (6 seconds) = 600
    [ChainId.MOONBEAM]: 600,
    // (60 minutes) / (3 seconds) = 1200
    [ChainId.BNB]: 1200,
    // (60 minutes) / (3 seconds) = 1200
    [ChainId.AVALANCHE]: 1200,
    // (60 minutes) / (33 seconds) = 148
    [ChainId.ROOTSTOCK]: 148,
    // (60 minutes) / (1 seconds) = 3600
    [ChainId.ZKSYNC]: 3600,
    [ChainId.MONAD_TESTNET]: 3600,
    // (60 minutes) / (1 seconds) = 3600
    [ChainId.SONEIUM]: 3600,
};
//# sourceMappingURL=data:application/json;base64,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